import { forwardRef } from "react";
import { useClickAway } from "react-use";
import { MenuOptionContainer } from "./menu-option-style";

export const MenuOptions = forwardRef(
   ({ options, optionsFns, onClose, visible, top, left, right, bottom, }, ref) => {
      function handleClick(index) {
         optionsFns[index]();
         onClose();
      }

      useClickAway(ref, () => {
         onClose();
      });

      return (
         <MenuOptionContainer visible={visible} ref={ref} style={{ top, right, left, bottom }}>
            {options?.map((option, index) => (
               <div
                  className={`option ${option.name === "Blacklist User" ? "blacklist-option" : option.name === "Activate User" ? "activate-option" : ""}`}
                  key={option.name}
                  onClick={() => handleClick(index)}
                  onKeyDown={() => handleClick(index)}
                  role="button"
                  tabIndex={0}
               >
                  {option.icon} <span>{option.name}</span>
               </div>
            ))}
         </MenuOptionContainer>
      );
   }
);
